export function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center ${className}`}>
      <svg 
        viewBox="0 0 400 120" 
        className="h-12 w-auto"
        fill="black" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* V - Larger, bolder design */}
        <path d="M20,20 L60,100 L100,20 L85,20 L60,80 L35,20 Z" />
        
        {/* Z - Larger lightning-style Z */}
        <path d="M110,20 L170,20 L110,100 L170,100 L170,85 L135,85 L195,35 L135,35 Z" />
        
        {/* M - Larger sharp peaks */}
        <path d="M200,100 L220,20 L260,80 L300,20 L320,100 L305,100 L290,40 L260,85 L230,40 L215,100 Z" />
        
        {/* O - Angular square design with Z-style diagonal */}
        <path d="M330,20 
                 L390,20 
                 L390,100 
                 L330,100 
                 Z
                 M345,35
                 L375,35
                 L345,85
                 L375,85
                 L375,35" />
      </svg>
    </div>
  );
}